import React, { Component } from 'react'

export default class OnlineWorksIntervistaLucaCoser extends Component {
  render() {
    return (
 <div class="modal" id="onlineworksintervistalucacoser" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
        <div class="modal-content">
        <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
            <div class="modal-header">
                <h5 class="modal-title">Testo dell’intervista ad Alessandro Tamburini, uscita sul Corriere della sera (pagine del “Corriere del Trentino”), a cura di Luca Coser, in data 8 marzo 2006</h5>

            </div>
            <div class="modal-body-testionline p-4" id="result">
            <p  ><span > </span></p>

<p ><b>LC:</b></p>   
            <p >
se ti penso non posso fare a meno di immaginarti mentre stai facendo <br/>
molte cose contemporaneamente, tutte nell'ambito della cultura e del <br/>
tuo &quot;mestiere di scrivere&quot; ma, in fin dei conti, come a se stanti.
sei <br/>
una persona molto attiva ed energica, estroversa. qual'è il posto che <br/>
riservi alla &quot;scrittura di un romanzo&quot; in quel movimento continuo che
è <br/>
la tua vita?</p>

<p ><span >&nbsp;</span></p>

<p  ><b><span >AT:</span></b></p>

<p ><span >In effetti svolgo diverse
attività, legate in vario modo alla cultura e alla scrittura. Ho pubblicato
romanzi e volumi di racconti, collaboro con quotidiani e riviste, ho
organizzato convegni e seminari. Sono stato molto spesso a parlare nelle
biblioteche, che considero dei vitali nuclei di resistenza della letteratura.
Poi ho avuto occasione di scrivere per il cinema e la televisione e cerco di
fare in modo che anche il mio lavoro di insegnante di lettere in una Scuola
media Superiore, a momenti arduo ma sempre ricco di soddisfazioni, sia a
contatto con tutto questo.</span></p>

<p  ><span >Sono
certamente una persona attiva e vado sempre in cerca di nuove idee e progetti,
di nuove storie da raccontare e anche di persone che condividano i miei
interessi, con cui poter avere uno scambio proficuo.</span></p>

<p  ><span >La
scrittura narrativa però, che vivo come il momento più importante di tutto il
mio lavoro, richiede molto tempo, molta concentrazione e una dedizione che in
certi periodi diventa assoluta. L’idea, il primo abbozzo di una storia che ho
voglia e a un certo punto necessità di scrivere, può prendere forma in un arco
di tempo anche lungo. Ma quando arriva il momento di cominciare proprio a
scriverla mi viene spontaneo dedicarmici per tutto il tempo disponibile. Se si tratta
di un racconto, la stesura può risolversi nell’arco di qualche settimana. Nel
caso di un romanzo il discorso è diverso. In genere impiego almeno tre o
quattro anni per scriverlo, un tempo lungo nel quale finiscono inevitabilmente
tante altre attività. Così succede che faccio delle lunghe immersioni nel
romanzo, durante le quali non penso ad altro. Poi me ne stacco per un po’, cosa
che fra l’altro giova anche alla decantazione e alla maturazione del testo, per
fare e scrivere altro.</span></p>

<p  ><span >Ho
un rapporto molto intenso e in certe fasi perfino maniacale con la scrittura.
Un mio libro esce in genere da almeno quattro o cinque riscritture e versioni
diverse. Parto con un’idea che nel corso del lavoro viene modificata, si evolve
e il risultato finale non coincide mai del tutto con le premesse. Guai se non
fosse così. Guai se proprio dalla scrittura non scaturisse qualcosa di nuovo e
inatteso. C’è il motto di un mio amato lirico greco che esprime bene questo
concetto: “Il bello è quando vanno bene, le cose, e i piani non riescono”.</span></p>

<p  ><span > </span></p>

<p ><b>LC:</b></p>

<p ><span >E’ vero, succede anche con il
mio lavoro pittorico. In arte è come se un progetto, un qualsiasi progetto non
fosse altro che il preavviso del suo stesso fallimento, e da questo la
possibilità di un senso poetico. A proposito di progetti, ne avevi in serbo uno
da molto tempo, che è diventato un romanzo e che tra breve verrà pubblicato da
una casa editrice per te nuova. </span></p>

<p  ><span >&nbsp;</span></p>

<p  ><b><span >AT:</span></b></p>

<p ><span >Il mio nuovo romanzo, che
arriverà in libreria in aprile, si intitola “Bagaglio leggero” e la prima
novità riguarda l’editore. Infatti, in sintonia con la mia agente, ho deciso di
affidarlo alla PeQuod, una casa editrice giovane e intraprendente, che si è
fatta un certo nome pubblicando autori esordienti e da qualche anno ospita nel
suo catalogo anche scrittori già affermati. Avevo bisogno di respirare aria
nuova, di sentire entusiasmo, voglia di fare, motivazioni forti e autentiche
intorno al libro, tutte cose che ho trovato alla PeQuod.</span></p>

<p  ><span >&nbsp;</span></p>

<p  ><b><span >LC:</span></b></p>

<p ><span >Questa “aria nuova” ha
portato dei cambiamenti anche nella tua scrittura? Di cosa parla il romanzo?</span></p>

<p  ><span >&nbsp;</span></p>

<p  ><b><span >AT:</span></b></p>

<p ><span >Il romanzo è ambientato ai
nostri giorni in una Casa di Riposo. A causa del ritrovamento di un ordigno
bellico, una delle tante bombe cadute fra il ’43 e il ’44, rimasta inesplosa, la Casa di Riposo deve essere sgomberata, una domenica di marzo, appunto per far brillare
l’ordigno. Accade quindi che persone molto anziane, alcune delle quali non
uscivano più da anni, si trovano costrette a vivere una giornata per loro
straordinaria e a ritrovare un contatto col mondo esterno che sovverte un
consolidato e delicato equilibrio di abitudini e sicurezze acquisite. </span></p>

<p  ><span >Si
raccontano i giorni che precedono la giornata fatidica, nei quali gli ospiti
della Casa parlano molto della bomba, e poi anche degli anni in cui era caduta,
cioè quelli della guerra e soprattutto della loro gioventù. La storia si avvale
quindi di una specie di macchina del tempo (il che è una costante dei miei
ultimi romanzi, a cominciare da “L’onore delle armi”), in cui le vicende
presenti si intersecano con quelle vissute dai protagonisti cinquant’anni
prima. </span></p>

<p  ><span >Per
tutta la prima parte del libro vi sono diversi personaggi, di pari spessore e
importanza, di cui seguiamo le storie. Quando poi arriva l’attesa e temuta
giornata dello sgombero, accade qualcosa di imprevisto, che ne coinvolge alcuni
in modo particolare, staccandoli dagli altri e avviandoli verso un finale che
risulta avvincente e sorprendente, per loro e mi auguro anche per il lettore.</span></p>

<p  ><span >Infine,
l’ambientazione: una città del nord Italia, di cui non sono indicati
esplicitamente dati identificativi, ma in cui non è difficile riconoscere
strade e luoghi di Trento, sia per quanto riguarda il tempo presente che per
quello della guerra. E’ la prima volta che mi succede di ambientare una storia
nella città dove vivo ormai da tanti anni.</span></p>

<p  ><span >&nbsp;</span></p>

<p  ><b><span >LC:</span></b></p>

<p ><span >Nel tuo romanzo precedente,
L’onore delle armi, ti confrontavi, da padre quale sei, con la figura paterna.
In questo nuovo romanzo sono ancora una volta protagonisti persone mature,
anziani, portatori di esperienza, storia, memoria. E’ una tua reazione
orgogliosa a tanto superficiale e pseudo-erotico giovanilismo, o cosa?</span></p>

<p  ><span >&nbsp;</span></p>

<p  ><b><span >AT:</span></b></p>

<p ><span >Proprio a partire da “L’onore
delle armi” mi sono spostato verso una narrativa rivolta alla realtà del mio
presente ma nel contempo anche ad altri piani temporali. Mi ero stancato di
esplorare il mio percorso generazionale. Mi interessava il confronto fra
generazioni diverse, in particolare con quella di mio padre, fatta di ragazzi
che a vent’anni si sono trovati catapultati dentro la guerra, altro che “sindrome
di Peter Pan”, di cui si parla riguardo ai giovani di oggi.</span></p>

<p  ><span >Per
quanto riguarda gli anziani, con il loro portato di storia e memoria, li ho
scelti spesso come protagonisti delle mie storie, a cominciare da “Ultima sera
dell’anno”, il mio primo libro di racconti pubblicato nell’ormai lontano 1988.</span></p>

<p  ><span >&nbsp;</span></p>

<p  ><b><span >LC:</span></b></p>

<p ><span >Hai sempre dato grande
importanza allo “scavo” dentro i personaggi, dentro la memoria, in questo senso
la tua è una scrittura difficile da classificare con precisione, di certo non
la si può definire una letteratura di “genere”. Cosa ne pensi della giovane
scrittura contemporanea in Italia?</span></p>

<p  ><span >&nbsp;</span></p>

<p  ><b><span >AT:</span></b></p>

<p ><span >Non ho mai avuto un grande
feeling con la letteratura di genere, a parte alcune eccezioni, come ad esempio
lo strepitoso Raymond Chandler. Per questo non mi trovo molto in sintonia con
buona parte dei giovani scrittori italiani di oggi, che invece puntano proprio
sul genere, sulla contaminazione fra generi diversi, spesso cercando l’effetto
ad ogni costo; per non parlare del pulp, con la sua visione parodistica e postuma
della narrazione, con l’appiattimento ai feticci e al linguaggio della
televisione. Io credo ancora nella possibilità della narrativa di raccontare
storie, nel senso più classico del termine, e lavoro in questa direzione.</span></p>

<p  ><span >&nbsp;</span></p>
			
            </div>
            <div class="modal-footer">
            Ultima Sera Dell'anno - Il lavoro editoriale,Ancona, 1988
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
        </div>
    </div>
</div>


    )
  }
}
